import Indicator from '../Indicator';

/** On Balance Volume indicator */
export default class OnBalanceVolumeIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 */
	_getDefaultParams() {
		return {
			id: 'onbalancevolume',
			name: 'On Balance Volume',
			description: 'On Balance Volume measures the strength of buying or selling pressure on a security. It represents the cumulative total of volume since indicator inception and adds volume on up days while subtracting the volume on down days.',
			componentSeries: [
				{ id: 'onbalancevolume' }
			]
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		this.cumulativeAdjustment = this._getCumulativeAdjustment();
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
